<template>
  <div>
    <!-- Button to open sidebar on mobile -->
    <div class="lg:hidden">
      <button @click="sidebarOpen = true" class="p-2 text-gray-400 hover:text-white siena-hover focus:outline-none focus:bg-indigo-700">
        <span class="sr-only">Open sidebar</span>
        <!-- Icone de hambúrguer -->
        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>
    </div>

    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog class="relative z-50 lg:hidden" @close="sidebarOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-900/80" />
        </TransitionChild>

        <div class="fixed inset-0 flex">
          <TransitionChild as="template" enter="transition ease-in-out duration-300 transform" enter-from="-translate-x-full" enter-to="translate-x-0" leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0" leave-to="-translate-x-full">
            <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
              <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                  <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                    <span class="sr-only">fechar aba lateral</span>
                    <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </TransitionChild>
              <!-- Sidebar component, swap this element with another sidebar if you like -->
              <div class="flex grow flex-col gap-y-5 overflow-y-auto custom-purple px-6 pb-4">
                <div class="flex h-16 shrink-0 items-center">
                  <img class="h-12 w-auto" src="../assets/Logo.png" alt="Siena" />
                </div>
                <nav class="flex flex-1 flex-col">
                  <ul role="list" class="flex flex-1 flex-col gap-y-7">
                    <li>
                      <ul role="list" class="-mx-2 space-y-1">
                        <li v-for="item in navigation" :key="item.name">
                          <router-link :to="item.link">
                            <a @click="activeItemName = item.name" :href="item.href" :class="[isActive(item.name) ? 'bg-sienaBlue text-white' : 'text-indigo-200 siena-hover hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6']">
                              <component :is="item.icon" :class="[isActive(item.name) ? 'text-white' : 'text-indigo-200 group-hover:text-white', 'h-6 w-6 shrink-0']" aria-hidden="true" />
                              {{ item.name }}
                            </a>
                          </router-link>
                        </li>
                      </ul>
                    </li>
                    <li class="mt-auto">
                      <a @click="sair" href="#" class="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-indigo-200 siena-hover hover:text-white">
                        <ArrowLeftOnRectangleIcon class="h-6 w-6 shrink-0 text-indigo-200 group-hover:text-white" aria-hidden="true" />
                        Sair
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>

    <!-- Static sidebar for desktop -->
    <div class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div class="flex grow flex-col gap-y-5 overflow-y-auto custom-purple px-6 pb-4">
        <div class="flex h-16 shrink-0 items-center">
          <img class="h-12 w-auto" src="../assets/Logo.png" alt="Siena" />
        </div>
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li>
              <ul role="list" class="-mx-2 space-y-1">
                <li v-for="item in filteredNavigation" :key="item.name">
                  <router-link :to="item.link">
                    <a @click="activeItemName = item.name" :href="item.href" :class="[isActive(item.name) ? 'bg-sienaBlue text-white' : 'text-indigo-200 siena-hover hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6']">
                      <component :is="item.icon" :class="[isActive(item.name) ? 'text-white' : 'text-indigo-200 group-hover:text-white', 'h-6 w-6 shrink-0']" aria-hidden="true" />
                      {{ item.name }}
                    </a>
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="mt-auto">
              <a @click="sair" href="#" class="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-indigo-200 siena-hover hover:text-white">
                <ArrowLeftOnRectangleIcon class="h-6 w-6 shrink-0 text-indigo-200 group-hover:text-white" aria-hidden="true" />
                Sair
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="lg:pl-72">
      <main class="py-10">
        <div class="px-4 sm:px-6 lg:px-8">
          <!-- Your content -->
          <div class="container mx-auto sm:px-6 lg:px-8">
              <!-- Content goes here -->
              <router-view></router-view>
          </div>

        </div>
      </main>
    </div>
  </div>
</template>
<script>
import {
  FolderIcon,
  UsersIcon,
  XMarkIcon,
  MapIcon,
  ClipboardDocumentListIcon,
  BriefcaseIcon,
  PencilSquareIcon,
  //HomeIcon,
  ArrowUpOnSquareIcon,
  PresentationChartBarIcon,
  DocumentDuplicateIcon,
  ArrowLeftOnRectangleIcon,
  DocumentCheckIcon,
  ShieldCheckIcon,
  ChartBarIcon
} from '@heroicons/vue/24/outline';
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
export default {
  
  name: 'MainDashiew',
  created(){
  },
  props: {
  },   
  data() {
      return {
        onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
        navigation: [
          { name: 'Dashboard', href: '#', icon: PresentationChartBarIcon, link: '/userdash', visibleTo: ['admin','master.justech'] },
          { name: 'Segurados/Associados', href: '#', icon: UsersIcon, link: '/segurados', visibleTo: ['admin','master.justech','agendadores'] },
          { name: 'Empresas', href: '#', icon: FolderIcon, link: '/empresas', visibleTo: ['admin','master.justech'] },
          { name: 'Seguradoras', href: '#', icon: ShieldCheckIcon, link: '/seguradoras', visibleTo: ['admin','master.justech'] },
          { name: 'Atendimentos WhatsApp', href: '#', icon: BriefcaseIcon, link: '/whats-app', visibleTo: ['admin', 'consultores', 'agendadores'] },
          { name: 'Triagem Clientes WhatsApp', href: '#', icon: BriefcaseIcon, link: '/whats-app/triagem', visibleTo: ['admin','master.justech','roteirizacao'] },
          { name: 'Planos', href: '#', icon: PencilSquareIcon, link: '/planos', visibleTo: ['admin','master.justech']},
          { name: 'Modelos de Propostas', href: '#', icon: DocumentDuplicateIcon, link: '/modelos-proposta', visibleTo: ['admin','master.justech'] },
          { name: 'Índices IPCA', href: '#', icon: ChartBarIcon, link: '/indices-ipca', visibleTo: ['admin','master.justech'] }, // Added new navigation item
          { name: 'Apólices', href: '#', icon: DocumentDuplicateIcon, link: '/apolices',visibleTo: ['admin','master.justech'] },
          //{ name: 'Histórico de Atendimentos', href: '#', icon: ClockIcon, link: '/historico', visibleTo: ['admin', 'master.justech','agendadores', 'roteirizacao',] },
          { name: 'Geração de Rotas', href: '#', icon: MapIcon, link: '/agendamentos', visibleTo: ['admin','master.justech','roteirizacao'] },
          { name: 'Rotas Geradas', href: '#', icon: ClipboardDocumentListIcon, link: '/listas-agendamentos', visibleTo: ['admin','master.justech','roteirizacao'] },
          { name: 'Minhas Rotas Geradas', href: '#', icon: ClipboardDocumentListIcon, link: '/listas-rotas', visibleTo: ['admin', 'consultores', 'agendadores','roteirizacao'] },
          { name: 'Visitas Consultores', href: '#', icon: BriefcaseIcon, link: '/visitas', visibleTo: ['admin', 'consultores'] },
          { name: 'Propostas', href: '#', icon: DocumentCheckIcon, link: '/propostas', visibleTo: ['admin','master.justech'] },
          { name: 'Gerencimento de Rotas', href: '#', icon: FolderIcon, link: '/gerenciamento-rotas', visibleTo: ['admin','master.justech'] },
          { name: 'Movimentações', href: '#', icon: BriefcaseIcon, link: '/movimentacoes', visibleTo: ['master.justech'] },
          { name: 'Meus Uploads', href: '#', icon: ArrowUpOnSquareIcon, link: '/uploads', visibleTo: ['admin', 'consultores', 'agendadores'] },
        ],
        sidebarOpen: false,
        activeItemName: ''
      };
  },
  computed: {
    filteredNavigation() {
      const grupos = this.onlineUser.user?.groups || [];
      return this.navigation.filter(item => {
        if (!item.visibleTo) return true;
        return item.visibleTo.some(grupo => grupos.includes(grupo));
      });
    }
  },
  methods: {
    isActive(name) {
      return this.activeItemName === name;
    },
    sair(){
        {
        window.localStorage.setItem("myUser", JSON.stringify({}));
        this.$router.push({ path: '/' });
      }
    },
  },
  components:{
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    ArrowLeftOnRectangleIcon,
    XMarkIcon,
    DocumentCheckIcon,
  },
}
</script>
<style scoped>
.custom-purple{
  background-color: #10327b;
}
.siena-hover:hover{
  background-color: #3bc3f5;
}
</style>